/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import { Breadcrumb, Col, FloatButton, Image, Modal, Row } from "antd";
import { MetaTags } from "react-meta-tags";
import { CommentOutlined, CloseOutlined } from "@ant-design/icons";
import AboutUsLogo from "../../../assets/images/about-us-5.jpg";
// import AboutUsLogo from "../../../assets/images/about-us-1.jpg";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { IoShieldCheckmarkSharp } from "react-icons/io5";
import "react-range-slider-input/dist/style.css";

const Aboutus = (props) => {
  const media = useMedia();
  // const packageDetailsData =
  //   props && props.location && props.location.state ? props.location.state : "";

  //Initial state

  const [chatModal, setChatModal] = useState(false);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  console.log(windowDimensions, "windowDimensions");
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Know More About Us | Plan mi trip</title>
        </MetaTags>
      </div>
      <Row>
        <Col
          md={24}
          sm={24}
          xs={24}
          lg={24}
          xl={24}
          xxl={24}
          className="mt-[-20px] sm:mt-[-10px] lg:mt-[42px] xl:mt-[-20px]"
        >
          <Image
            src={AboutUsLogo}
            preview={false}
            width={"101%"}
            className="ml-[-10px]"
            height={280}
          />
        </Col>
      </Row>
      <Row
        className={
          media == "sm"
            ? "pr-[6%] pl-[6%] w-[100%]"
            : media == "xs"
            ? "pr-[40px] pl-[40px] w-[100%]"
            : media == "md"
            ? "pr-[7%] pl-[7%] w-[100%]"
            : media == "lg"
            ? "pr-[10%] pl-[10%] w-[100%] mt-[10px]"
            : media == "xxl"
            ? "pr-[8.5%] pl-[11%] w-[100%]"
            : "pr-[8%] pl-[6.5%] w-[100%]"
          // media === "md"
          //   ? "mt-10 pl-[140px] pr-[120px] w-[100%]"
          //   : media == "sm" || media == "xs"
          //   ? "pl-[40px] pr-[30px] w-[100%]"
          //   : "pl-[140px] pr-[120px] w-[100%]"
        }
      >
        <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
          {/* <div>
            <h1
              style={{
                fontFamily: "Poppins",
              }}
              className="text-[24px] font-extrabold mb-3"
            >
              Know More About Us - Plan mi trip
            </h1>
          </div> */}
        </Col>
        <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24} className="mt-2">
          <Breadcrumb
            style={{
              fontFamily: "Poppins",
              color: "blue",
              fontSize: "12px",
            }}
            items={[
              {
                href: "/",
                title: "Home",
                separator: ">",
              },
              {
                // path: "/packages",
                title: "Know More About Us - Plan mi trip",
                // separator: ">",
              },
            ]}
          />
        </Col>
        <Col
          md={24}
          sm={24}
          xs={24}
          lg={24}
          xl={24}
          xxl={24}
          className="mb-[-50px]"
        >
          <Row className="mt-3">
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="mb-2"
              // className="mt-3 p-2"
            >
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] font-semibold mb-[5px]"
              >
                About us
              </div>
            </Col>
            <Col
              md={24}
              sm={24}
              xs={24}
              lg={24}
              xl={24}
              xxl={24}
              className="border border-2 shadow-sm p-4 rounded-sm"
            >
              <Row>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={24}
                  sm={24}
                  xs={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                >
                  <h1 className="text-[14px] uppercase font-semibold mb-3">
                    Our Organization
                  </h1>

                  <p className="text-[13px] font-normal mb-3">
                    Plan mi trip was established in 1949. Since then, it has
                    escorted lakhs of travelers across the globe for more than 6
                    years to various destinations around the world. It is one of
                    the leaders in segments, namely Escorted Group Tours,
                    Customised Holidays, Holidays of India and Incentive Travel
                    amongst others. Plan mi trip’s customer focus, innovation
                    and operational excellence has not only tapped the existing
                    market potential but has also created new markets through
                    innovative packages. Its vast array of holiday services is
                    taking holidaying to an entirely new level. A new age
                    innovative holiday maker, Plan mi trip strives to make
                    holidays a priority for every Indian.
                  </p>
                </Col>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={24}
                  sm={24}
                  xs={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                >
                  <h1 className="text-[14px] uppercase font-semibold mb-3">
                    Leisure Travel
                  </h1>
                  <p className="text-[13px] font-normal mb-3">
                    Plan mi trip has been the pioneer in the development of
                    organized leisure travel in the Outbound and Domestic
                    division. Its leisure segment includes offerings namely,
                    Escorted Group Tours, Customised Holidays, Luxury Holidays
                    and Holidays of India.
                  </p>
                  <p className="text-[13px] font-normal mb-3">
                    With its extensive and continuously expanding network of
                    sales offices across India, the leisure business has been
                    undertaking path-breaking initiatives to reach out to
                    travelers through innovative products. It has pioneered the
                    concept of one day road shows named Holiday Bazaars that
                    promote international and domestic escorted and group tours
                    in India that endeavor to bring to life our customers dream
                    holidays. Plan mi trip Travel is the pioneer in Indian
                    travel space to enter the integrated spiritual + leisure
                    segment with the introduction of Spiritual Tours named
                    Darshans. Perfect Moments- Luxury Travel by Plan mi trip
                    seeks to redefine luxury travel cliches for connoisseurs.
                    Our exclusive collection of luxury experiences are curated
                    and designed exclusively for esteemed and discerning
                    travellers across the world.
                  </p>
                  {/* <p className="text-[13px] font-normal mb-3">
                    The company is an innovator in introducing the co-created
                    initiative in the Leisure Holiday Space. The co-created
                    initiative is a platform which invites customers to spell
                    out their most important expectations from a Holiday so as
                    to enhance and deliver an enriching holiday experience. Plan
                    mi trip also organises tours for Non Resident Indians (NRIs)
                    in the US, the UK, the Middle East and Africa.
                  </p> */}
                </Col>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={24}
                  sm={24}
                  xs={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                >
                  <h1 className="text-[14px] uppercase font-semibold mb-3">
                    Incentive Travel
                  </h1>
                  <p className="text-[13px] font-normal mb-3">
                    With a dedicated team of over 100 professionals across India
                    who specialize only in meetings, incentives, conferences and
                    events, Plan mi trip's customer focused strategies and
                    national reach have consistently ensured our market
                    leadership in the MICE segment of the outbound travel arena.
                  </p>
                </Col>
                <Col
                  style={{
                    fontFamily: "Poppins",
                  }}
                  md={24}
                  sm={24}
                  xs={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                >
                  <h1 className="text-[14px] uppercase font-semibold mb-3">
                    Business Travel
                  </h1>
                  <p className="text-[13px] font-normal">
                    Business Travel is India's leading travel management
                    company. With leading edge technology, user-oriented
                    software applications and strong focus on service and
                    customer needs, it has firmly established itself as the
                    expert in the business travel sector. Many of India's top
                    companies have chosen Business Travel for its global
                    capabilities and specialist local expertise.
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>
          <Modal
            open={chatModal}
            title=""
            maskClosable={false}
            onClose={() => setChatModal(false)}
            // onCancel={() => setChatModal(false)}
            // onCancel={false}
            closable
            footer={null}
            closeIcon={
              <CloseOutlined
                onClick={() => setChatModal(false)}
                className="text-[#ffffff]"
              />
            }
            width={600}
          >
            {/* <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          /> */}
            <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
              <div className="w-[107%] ml-[-20px] mt-[-16px] h-[200px] global-modal-img rounded-md">
                <Row>
                  <Col
                    style={{
                      fontFamily: "Poppins",
                    }}
                    md={12}
                    sm={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className="p-3"
                  >
                    <h2 className="text-[#ffffff]">
                      Don't miss out on our exclusive deals & insider only
                      offers!
                    </h2>
                    <div className="text-[#ffffff] mt-2">
                      <div className="flex">
                        <p>
                          <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                        </p>
                        5 years of Experience in India
                      </div>
                      <div className="flex">
                        <p>
                          <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                        </p>
                        Packages across 50 + Countries
                      </div>
                      <div className="flex">
                        <p>
                          <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                        </p>
                        Best Travel Partner of India
                      </div>
                    </div>
                  </Col>
                  <Col md={12} sm={12} lg={12} xl={12} xxl={12}></Col>
                </Row>
              </div>
            </Col>

            {/* <Collapse
            items={paymentFaqList}
            expandIcon={<DownCircleOutlined />}
            expandIconPosition="right"
            className="font-semibold"
            bordered
            style={{
              fontFamily: "Poppins",
            }}
          /> */}
          </Modal>
          <FloatButton
            className="w-[50px] h-[50px]"
            type="primary"
            style={{
              margin: "-7px",
            }}
            onClick={() => setChatModal(!chatModal)}
            icon={<CommentOutlined />}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

Aboutus.propTypes = {
  location: PropTypes.any,
};

export default withRouter(Aboutus);
